module.exports = __webpack_public_path__ + "static/media/editActivityOpt2.bc2710e3.png";